import React from 'react';
import { Modal, Button } from 'react-bootstrap';

export function CompareResultModal({ show, onHide, result }) {
  if (!result) return null;

  const swatchStyle = {
    width: 60,
    height: 60,
    borderRadius: '8px',
    border: '2px solid #bbb',
    marginRight: 16,
    flexShrink: 0,
  };

  const productContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 12,
  };

  const textBlockStyle = {
    display: 'flex',
    flexDirection: 'column',
  };

  const containerStyle = {
    display: 'flex',
    justifyContent: 'space-around',
    marginBottom: 24,
  };

  const percentStyle = {
    textAlign: 'center',
    fontWeight: '600',
    fontSize: '1.1rem',
  };

  const noteStyle = {
    fontSize: '0.9rem',
    color: '#666',
    fontStyle: 'italic',
    textAlign: 'center',
    marginTop: 8,
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Product Comparison Result</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={containerStyle}>
          {/* Left Product */}
          <div style={productContainerStyle}>
            <div style={{ ...swatchStyle, backgroundColor: result.left.shadeHex }} />
            <div style={textBlockStyle}>
              <strong>{result.left.brand}</strong>
              <span>{result.left.product}</span>
              <span style={{ fontWeight: 'bold' }}>{result.left.shade}</span>
              <span style={{ fontFamily: 'monospace', marginTop: 4 }}>{result.left.shadeHex}</span>
            </div>
          </div>

          {/* Right Product */}
          <div style={productContainerStyle}>
            <div style={{ ...swatchStyle, backgroundColor: result.right.shadeHex }} />
            <div style={textBlockStyle}>
              <strong>{result.right.brand}</strong>
              <span>{result.right.product}</span>
              <span style={{ fontWeight: 'bold' }}>{result.right.shade}</span>
              <span style={{ fontFamily: 'monospace', marginTop: 4 }}>{result.right.shadeHex}</span>
            </div>
          </div>
        </div>

        <div style={percentStyle}>
          Comparison Match: {result.percentMatch}%
        </div>
        <div style={noteStyle}>
          Matches above 95% are generally acceptable. Matches between 98% and 100% represent differences virtually imperceptible to the human eye.
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button style={{background:"#7D7ABC"}} onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}
